<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const emit = defineEmits(['close'])
</script>

<template>
  <div class="sidebar-panel is-generic">
    <div class="subpanel-header">
      <h3 class="no-mb">{{ t('sidebar-finance') }}</h3>
      <div class="panel-close" @click="emit('close')">
        <i aria-hidden="true" class="iconify" data-icon="feather:x"></i>
      </div>
    </div>
    <div class="inner" data-simplebar>
      <ul>
        <li>
          <RouterLink :to="{ name: 'finance-orders-list' }">
            <i class="lnir lnir-layers" aria-hidden="true"></i>
            {{ t('sidebar-finance-order-list') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'finance-statistics' }">
            <i class="fas fa-poll" aria-hidden="true"></i>
            {{ t('sidebar-finance-statistics') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-panel.scss';
</style>
